const pid = {
  'pid.input.empty': 'Campo vazio',
  'pid.DIA_NASCIMENTO': 'Dia do nascimento',
  'pid.MES_NASCIMENTO': 'Mês do nascimento',
  'pid.ANO_NASCIMENTO': 'Ano do nascimento',
  'pid.CPF': 'CPF',
  'pid.CEP_RESIDENCIAL': 'CEP',
  'pid.RG': 'RG',
  'pid.ESTADO_CIVIL': 'Estado civil',
  'pid.PRIMEIRO_NOME_MAE': 'Primeiro nome da mãe',
  'pid.verifyAnswers': 'Confirme as respostas antes de enviar',
  'pid.question': 'Pergunta',
  'pid.send': 'Salvar',
  'pid.continue': 'Continuar',
  'pid.restart': 'Começar novamente',
  'pid.submit.success': 'Confirmação positiva realizada com sucesso',
  'pid.submit.error': 'Cuidado! Respostas erradas',
  'pid.submit.expired':
    'Identificação positiva expirada. Por favor comece novamente',
};

export default pid;
